/*  @IEPrintIssueModalComponent used to display modal when user clicks on paper free and print statment in case of IE */
import React from 'react';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import InternetBankingActions from '../../actions/InternetBankingActions';
import HelpActionCreator from '../../actions/HelpActionCreator';

export default class IEPrintIssueModalComponent extends React.Component {
  constructor(props) {
    super(props);
    this.getPaperFreeModalHeading = this.getPaperFreeModalHeading.bind(this);
    this.getPaperFreeBody = this.getPaperFreeBody.bind(this);
    this.getPaperFreeFooter = this.getPaperFreeFooter.bind(this);
    this.getModalBody = this.getModalBody.bind(this);
    this.getIEPrintIssueBody = this.getIEPrintIssueBody.bind(this);
    this.getIEPrintIssueFooter = this.getIEPrintIssueFooter.bind(this);
    this.getModalFooter = this.getModalFooter.bind(this);
    this.faqAnchorClick = this.faqAnchorClick.bind(this);
  }

  getIEPrintIssueBody() {
    return (
      <div>
        <p>
          {this.props.content.IEPrintIssueModalBody3}
          <a href="javascript:;" onClick={this.faqAnchorClick}>
            {this.props.content.checkoutFAQ}
          </a>
        </p>
      </div>
    );
  }

  getIEPrintIssueFooter() {
    return (
      <div className="button-group">
        <button
          className="c-btn c-modal__button c-btn--default"
          tabIndex="0"
          onClick={this.props.closeAction}
        >
          {this.props.content.ok}
        </button>
      </div>
    );
  }

  getModalBody() {
    return this.props.fromPrint
      ? this.getIEPrintIssueBody()
      : this.getPaperFreeBody();
  }

  getModalFooter() {
    return this.props.fromPrint
      ? this.getIEPrintIssueFooter()
      : this.getPaperFreeFooter();
  }

  getPaperFreeBody() {
    return (
      <div>
        <p>{this.props.content.IEPrintIssueModalBody1}</p>
        <p>
          {this.props.content.IEPrintIssueModalBody2}
          <a href="javascript:;" onClick={this.faqAnchorClick}>
            {this.props.content.checkoutFAQ}
          </a>
        </p>
      </div>
    );
  }

  getPaperFreeFooter() {
    return (
      <div className="button-group">
        <button
          className="c-btn c-modal__button c-btn--secondary"
          tabIndex="0"
          onClick={this.props.closeAction}
        >
          {this.props.content.cancelButtonText}
        </button>
        <button
          className="c-btn c-modal__button c-btn--default"
          tabIndex="0"
          onClick={this.props.continueAction}
        >
          {this.props.content.continueButtonText}
        </button>
      </div>
    );
  }

  getPaperFreeModalHeading() {
    return <strong>{this.props.content.IEPrintIssueModalHeading}</strong>;
  }

  faqAnchorClick() {
    HelpActionCreator.backSetUrl(
      this.props.fromPrint
        ? 'WEB-DIGITAL-STATEMENTS'
        : 'WEB-STATEMENTS-PREFERENCES',
      this.props.content.prefrenceUrl
    );
    InternetBankingActions.navigateToWebTask('WEB-OPEN-FAQ');
  }

  render() {
    return (
      <PatternLibModalComponent
        show={this.props.showModal}
        onHide={this.props.closeAction}
        bsSize={'medium'}
        modalHeading={this.getPaperFreeModalHeading()}
        modalBody={this.getModalBody()}
        modalFooter={this.getModalFooter()}
        customClass={'c-modal'}
        closeButton={this.props.closeAction}
      />
    );
  }
}
